import {
  SMVM_GET_ANSWER_ASSESSEE_FAIL,
  SMVM_GET_ANSWER_ASSESSEE_REQUEST,
  SMVM_GET_ANSWER_ASSESSEE_RESET,
  SMVM_GET_ANSWER_ASSESSEE_SUCCESS,
  SMVM_GET_LIST_ANSWER_ASSESSEE_FAIL,
  SMVM_GET_LIST_ANSWER_ASSESSEE_REQUEST,
  SMVM_GET_LIST_ANSWER_ASSESSEE_RESET,
  SMVM_GET_LIST_ANSWER_ASSESSEE_SUCCESS,
  SMVM_SET_ANSWER_ASSESSEE_FAIL,
  SMVM_SET_ANSWER_ASSESSEE_REQUEST,
  SMVM_SET_ANSWER_ASSESSEE_RESET,
  SMVM_SET_ANSWER_ASSESSEE_SUCCESS,
} from "../constants/AnswerAssesseeContants";

export const smvm_set_answer_assessee_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case SMVM_SET_ANSWER_ASSESSEE_REQUEST:
      return { loading: true };
    case SMVM_SET_ANSWER_ASSESSEE_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_SET_ANSWER_ASSESSEE_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_SET_ANSWER_ASSESSEE_RESET:
      return {};
    default:
      return state;
  }
};

export const smvm_get_answer_assessee_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case SMVM_GET_ANSWER_ASSESSEE_REQUEST:
      return { loading: true };
    case SMVM_GET_ANSWER_ASSESSEE_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_GET_ANSWER_ASSESSEE_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_GET_ANSWER_ASSESSEE_RESET:
      return {};
    default:
      return state;
  }
};

export const smvm_get_list_answer_assessee_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case SMVM_GET_LIST_ANSWER_ASSESSEE_REQUEST:
      return { loading: true };
    case SMVM_GET_LIST_ANSWER_ASSESSEE_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_GET_LIST_ANSWER_ASSESSEE_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_GET_LIST_ANSWER_ASSESSEE_RESET:
      return {};
    default:
      return state;
  }
};
